import React from 'react';
import { Route, Link, Switch } from 'react-router-dom';
import { useStoreState } from '~/store';
import NavList from 'Components/nui/NavList';
import { matchUrl, routeUrl } from '~/router';

export default () => {
  const edit = useStoreState(
    state =>
      state.auth.solution.roles
        .map(r => r.division.edittenders)
        .includes(true) &&
      (state.auth.solution.tenderlogic === 'purchase'
        ? state.auth.solution.roles.map(r => r.role).includes('manager')
        : state.auth.solution.roles.map(r => r.role).includes('manager') ||
          state.auth.solution.roles.map(r => r.role).includes('trader'))
  );

  return (
    <Switch>
      <Route path={matchUrl('tender-new')} />
      <Route path={matchUrl('tender-view')} />
      <Route>
        {edit && (
          <Link
            className="nui-button nui-primary new-tender"
            title="Create a new tender"
            to={routeUrl('tender-new')}
          >
            New tender
          </Link>
        )}
        <NavList>
          <NavList.Tab
            exact
            url={routeUrl('tender-overview')}
            path={matchUrl('tender-overview')}
          >
            Overview
          </NavList.Tab>
          <NavList.Tab
            url={routeUrl('tender-history')}
            path={matchUrl('tender-history')}
          >
            History
          </NavList.Tab>
        </NavList>
      </Route>
    </Switch>
  );
};
